import { Auth } from 'aws-amplify'

const url = `https://4ah6p2plk7.execute-api.us-east-1.amazonaws.com/dev/days/`
const method = 'DELETE'

export const deleteDay = async (id: string) => {
  // Get the user's token from aws-amplify
  const token = await Auth.currentSession()

  // Add the date timestamp to the url
  let updatedUrl = url + id

  const response = await fetch(updatedUrl, {
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${token.getIdToken().getJwtToken()}`,
    },
  })

  if (response.status !== 200) {
    throw new Error('Could not delete the day')
  }

  const json = await response.json()
  return json
}

// deleteAllDays too
